<template>
  <div class="table-scroll">
    <table class="data-table">
      <thead class="table-header">
        <tr>
          <th>#</th>
          <th v-for="col in cabeceras?.filter((c) => c.isVisible !== false)" :key="col.columnName">
            <span
              v-if="
                col.columnName === MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.STATUS].columnName
              "
              class="sortable-header"
              @click="toggleEstadoSort"
            >
              {{ col.columnName.toUpperCase() }}
              <img
                v-if="estadoSortDirection === 'asc'"
                src="@/assets/asc-order-arrow.svg"
                alt="Asc"
                width="12"
                height="12"
              />
              <img v-else src="@/assets/desc-order-arrow.svg" alt="Desc" width="12" height="12" />
            </span>
            <template v-else>
              {{ col.columnName.toUpperCase() }}
            </template>
          </th>
          <th v-if="showDeleteColumn"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(employee, rowIdx) in filteredTableData"
          :key="rowIdx"
          :class="{ 'registered-row': isRowRegistered(employee) }"
        >
          <td>{{ rowIdx + 1 }}</td>
          <td
            v-for="col in employee.columns?.filter((c) => c.isVisible !== false)"
            :key="col.columnName"
          >
            <div
              v-if="
                col.columnName === MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.STATUS].columnName
              "
              class="status-cell"
            >
              <span class="status-badge" :class="`status-${col.columnValue.toLowerCase()}`">
                <InfoButton
                  :messages="
                    col.columnValue === RegisterStatus.REGISTERED
                      ? ['']
                      : [col.columnDescription || '']
                  "
                  :type="col.columnValue"
                />
                {{ getRegisterStatusPresentation(col.columnValue as RegisterStatus) }}
              </span>
            </div>
            <div
              class="input-with-info"
              v-else-if="
                col.columnName !== 'Producto' &&
                col.columnName !==
                  MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.PAYMENT].columnName
              "
            >
              <input
                v-model="col.columnValue"
                :class="{
                  'error-cell': !col.isValid || col.isRepeated,
                  'unsaved-cell': col.isDirty,
                }"
                :disabled="
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.EMAIL].columnName ||
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.RFC].columnName ||
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.PHONE].columnName ||
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME].columnName ||
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME_MOTHER].columnName ||
                  col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.FIRST_NAME].columnName
                    ? !isCellEditing(rowIdx, col.type!, col.columnName) && isRowRegistered(employee)
                    : isRowRegistered(employee) || props.disableAllInputs
                "
                @input="handleInputChange(col, $event)"
                @blur="handleFieldBlur(col, rowIdx)"
              />
              <InfoButton
                v-if="col.isOriginalRepeated"
                :messages="[col.columnName + ' valor original repetido']"
                :type="'info'"
              />
              <InfoButton
                v-else-if="col.isRepeated"
                :messages="[col.columnName + ' repetido']"
                :type="'error'"
              />
              <InfoButton
                v-else-if="!col.isValid"
                :messages="[col.columnName + ' inválido']"
                :type="'error'"
              />
              <EditFieldButton
                v-if="
                  (col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.EMAIL].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.PHONE].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.RFC].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME_MOTHER].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.FIRST_NAME].columnName) &&
                  employee.columns?.[MEMBER_COLUMNS_POSITION.STATUS]?.columnValue ==
                    RegisterStatus.REGISTERED &&
                  !isCellEditing(rowIdx, col.type!, col.columnName)
                "
                @click="startEditing(rowIdx, col.type!, col.columnName)"
              />
              <SaveFieldButton
                v-if="
                  (col.columnName ===
                    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.EMAIL].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.PHONE].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.RFC].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME_MOTHER].columnName ||
                    col.columnName ===
                      MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.FIRST_NAME].columnName) &&
                  employee.columns?.[MEMBER_COLUMNS_POSITION.STATUS]?.columnValue ==
                    RegisterStatus.REGISTERED &&
                  isCellEditing(rowIdx, col.type!, col.columnName)
                "
                :disabled="isSaving"
                @mousedown="saveEditing(rowIdx, employee, col.type!, col.columnName)"
                :isLoading="isSaving"
              />
            </div>
            <div v-else-if="col.columnName === 'Producto' && !useProductoInput">
              <select
                v-model="col.columnValue"
                :class="{ 'error-cell': !col.isValid || col.isRepeated }"
                :disabled="isRowRegistered(employee) || props.disableAllInputs"
                @change="reValidateData(col)"
              >
                <option disabled value="">Seleccionar</option>
                <option value="MM1">{{ ProductName.MM1 }}</option>
                <option value="MM2">{{ ProductName.MM2 }}</option>
              </select>
            </div>
            <div v-else-if="col.columnName === 'Producto' && useProductoInput">
              <input v-model="col.columnValue" class="producto-input" disabled />
            </div>
            <div
              v-else-if="
                col.columnName ===
                MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.PAYMENT].columnName
              "
            >
              <select
                v-model="col.columnValue"
                :class="{ 'error-cell': !col.isValid || col.isRepeated }"
                :disabled="isRowRegistered(employee) || props.disableAllInputs"
                @change="reValidateData(col)"
              >
                <option disabled value="">Seleccionar</option>
                <option :value="PaymentFrequency.ANUAL">{{ 'Anual' }}</option>
                <option :value="PaymentFrequency.MENSUAL">{{ 'Mensual' }}</option>
              </select>
            </div>
          </td>
          <td v-if="showDeleteColumn">
            <button class="trash-btn" @click="confirmationBeforeRemoveRow(rowIdx)">
              <img src="@/assets/trash-icon-gray.svg" alt="Eliminar" width="15" height="15" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import InfoButton from './InfoButton.vue'
import { ColumnType, PaymentFrequency, type MemberColumnInfo, type MembersData } from 'commons'
import {
  RegisterStatus,
  getRegisterStatusOrder,
  getRegisterStatusPresentation,
} from '../../../commons/src/data-validator/dto/register-status-enum'
import {
  MEMBER_COLUMNS_POSITION,
  MEMBERS_FILE_STRUCTURE,
} from 'commons/src/data-validator/dto/members-file-structure'
import SaveFieldButton from '@/components/SaveFieldButton.vue'
import EditFieldButton from './EditFieldButton.vue'
import { ProductName } from 'commons'

// Track editing at the cell level: map rowIdx -> array of columnNames currently being edited
const editingCells = ref<Record<number, string[]>>({})
// Store original values per row and per columnName so we can revert edits if needed
const originalValues = ref<Record<number, Record<string, string>>>({})
const isSaving = ref(false)

const isCellEditing = (rowIdx: number, columnType: ColumnType, columnName?: string) => {
  if (!editingCells.value[rowIdx]) return false
  if (columnType === ColumnType.TEXT && columnName) {
    return editingCells.value[rowIdx].includes(columnName)
  }
  return editingCells.value[rowIdx].includes(columnType)
}

const addEditingCell = (rowIdx: number, columnType: ColumnType, columnName?: string) => {
  if (!editingCells.value[rowIdx]) editingCells.value[rowIdx] = []
  if (columnType === ColumnType.TEXT && columnName) {
    if (!editingCells.value[rowIdx].includes(columnName))
      editingCells.value[rowIdx].push(columnName)
  } else {
    if (!editingCells.value[rowIdx].includes(columnType))
      editingCells.value[rowIdx].push(columnType)
  }
}

const removeEditingCell = (rowIdx: number, columnType?: ColumnType, columnName?: string) => {
  const cells = editingCells.value[rowIdx]
  if (!cells) return
  if (columnType) {
    if (columnType === ColumnType.TEXT && columnName) {
      editingCells.value[rowIdx] = cells.filter((c) => c !== columnName)
    } else {
      editingCells.value[rowIdx] = cells.filter((c) => c !== columnType)
    }
    if (editingCells.value[rowIdx].length === 0) delete editingCells.value[rowIdx]
  } else {
    delete editingCells.value[rowIdx]
  }
}

const startEditing = (rowIdx: number, columnType?: ColumnType, columnName?: string) => {
  const employee = filteredTableData.value[rowIdx]
  if (!employee || !columnType) return

  let col
  if (columnType === ColumnType.TEXT && columnName) {
    col = employee.columns?.find((c) => c.columnName === columnName)
  } else {
    col = employee.columns?.find((c) => c.type === columnType)
  }
  if (!col) return

  if (!originalValues.value[rowIdx]) originalValues.value[rowIdx] = {}
  // store only the original value for this specific column
  if (columnType === ColumnType.TEXT && columnName) {
    originalValues.value[rowIdx][columnName] = col.columnValue
    addEditingCell(rowIdx, columnType, columnName)
  } else {
    originalValues.value[rowIdx][columnType] = col.columnValue
    addEditingCell(rowIdx, columnType)
  }
}

const saveEditing = async (
  rowIdx: number,
  employee: MembersData,
  columnType?: ColumnType,
  columnName?: string,
) => {
  isSaving.value = true
  const success = await props.saveUpdatedField(employee, columnType!, columnName)
  if (success) {
    // remove the editing flag for this specific cell (or whole row if columnName omitted)
    removeEditingCell(rowIdx, columnType, columnName)
    // if a specific column was provided, remove only that original value
    if (columnType && originalValues.value[rowIdx]) {
      delete originalValues.value[rowIdx][columnType]
      // if no more original values for the row, remove the row key
      if (Object.keys(originalValues.value[rowIdx]).length === 0) {
        delete originalValues.value[rowIdx]
      }
    } else {
      // remove any stored originals for the whole row
      delete originalValues.value[rowIdx]
    }
  }
  isSaving.value = false
}

function handleFieldBlur(col: MemberColumnInfo, rowIdx: number) {
  if (isSaving.value) return
  if (!isCellEditing(rowIdx, col.type!, col.columnName)) return

  const rowOriginals = originalValues.value[rowIdx]
  if (!rowOriginals) return

  const orig = rowOriginals[col.type!]
  if (orig !== undefined) {
    col.columnValue = orig
    // remove stored original for this column
    delete rowOriginals[col.type!]
    // if no more originals, remove the row from editing tracking
    if (Object.keys(rowOriginals).length === 0) {
      delete originalValues.value[rowIdx]
      removeEditingCell(rowIdx, col.type!, col.columnName)
    }
    props.reValidateData(col)
  }
}

interface Props {
  tableData: MembersData[]
  showOnlyInconsistencies: boolean
  isRowRegistered: (row: MembersData) => boolean
  reValidateData: (col: MemberColumnInfo) => void
  confirmationBeforeRemoveRow: (rowIdx: number) => void
  getRowStatus: (rowIdx: number) => string
  getFieldErrors: (col: MemberColumnInfo) => string[]
  showDeleteColumn?: boolean
  useProductoInput?: boolean
  enableZebraStriping?: boolean
  disableAllInputs?: boolean
  cabeceras?: MemberColumnInfo[]
  saveUpdatedField: (employee: MembersData, field: string, columnName?: string) => Promise<boolean>
}

const props = withDefaults(defineProps<Props>(), {
  showDeleteColumn: true,
  useProductoInput: false,
  enableZebraStriping: false,
  disableAllInputs: false,
})

const estadoSortDirection = ref<'asc' | 'desc' | null>(null)

function toggleEstadoSort() {
  if (estadoSortDirection.value === null) {
    estadoSortDirection.value = 'asc'
  } else {
    estadoSortDirection.value = estadoSortDirection.value === 'asc' ? 'desc' : 'asc'
  }
}

const filteredTableData = computed(() => {
  let data = props.showOnlyInconsistencies
    ? props.tableData.filter((row) => rowHasErrors(row))
    : props.tableData.slice()
  // Solo ordenar si el usuario lo solicita
  if (estadoSortDirection.value) {
    data = data.slice().sort((a, b) => {
      const valA = getRegisterStatusOrder(
        (a?.columns?.[MEMBER_COLUMNS_POSITION.STATUS]?.columnValue as RegisterStatus) ?? '',
      )
      const valB = getRegisterStatusOrder(
        (b?.columns?.[MEMBER_COLUMNS_POSITION.STATUS]?.columnValue as RegisterStatus) ?? '',
      )
      if (valA < valB) return estadoSortDirection.value === 'asc' ? -1 : 1
      if (valA > valB) return estadoSortDirection.value === 'asc' ? 1 : -1
      return 0
    })
  }
  return data
})

const rowHasErrors = (row: MembersData) => {
  return row.columns?.some((col) => !col.isValid || col.isRepeated)
}

type PopoverState = { show: boolean; top: number; left: number }
const buttonRefs = ref<Array<HTMLElement | null>>([])
const popoverRefs = ref<Array<unknown>>([])
const popoverStates = ref<Array<PopoverState>>([])

watch(
  () => filteredTableData.value.length,
  (newLen) => {
    buttonRefs.value.length = newLen
    popoverRefs.value.length = newLen
    popoverStates.value.length = newLen
    for (let i = 0; i < newLen; i++) {
      if (!popoverStates.value[i]) popoverStates.value[i] = { show: false, top: 0, left: 0 }
    }
  },
  { immediate: true },
)

function handleInputChange(col: MemberColumnInfo, event: Event) {
  const target = event.target as HTMLInputElement

  const lastNameColumn = MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME].columnName
  const lastNameMotherColumn =
    MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.LAST_NAME_MOTHER].columnName
  const firstNameColumn = MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.FIRST_NAME].columnName
  const rfcColumn = MEMBERS_FILE_STRUCTURE[MEMBER_COLUMNS_POSITION.RFC].columnName

  if (
    col.columnName === lastNameColumn ||
    col.columnName === lastNameMotherColumn ||
    col.columnName === firstNameColumn ||
    col.columnName === rfcColumn
  ) {
    col.columnValue = target.value.toUpperCase()
  } else {
    col.columnValue = target.value
  }
  props.reValidateData(col)
}
</script>

<style scoped>
.table-scroll {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  min-width: 700px;
}

.data-table th,
.data-table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: center;
}

.data-table thead {
  background: #003896;
  color: #fff;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* Inherit styles from parent th */
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4em;
  border-radius: 24px;
  font-size: 0.6rem;
  font-weight: 800;
  padding: 4px 12px;
  border: 1px solid;
  width: fit-content;
  height: 25px;
  text-align: center;
}

.status-registered {
  background: #aed491;
  color: #3f7623;
  border-color: #348127;
}

.status-error {
  background: #ffada9;
  color: #a83535;
  border-color: #ff6a63;
}

.status-not_registered {
  background: #91c9ff;
  color: #003ea7;
  border-color: #76aeff;
}

.status-not_registered_edited {
  background: #d5d5d5;
  color: #44587a;
  border-color: #677ea0;
}

.status-error_edited {
  background: #d5d5d5;
  color: #733f3f;
  border-color: #e49590;
}

.status-legacy {
  background: #d5d5d5;
  color: #616469;
  border-color: #677ea0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: 4px;
  border-radius: 24px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 130%;
  text-align: center;
  border: 1px solid;
  width: 54px;
  height: 25px;
}

.status-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-with-info {
  position: relative;
}

.error-cell {
  border-color: #d32f2f !important;
}

.unsaved-cell {
  color: #888 !important;
}

.producto-input {
  border: none !important;
  background: transparent !important;
  outline: none !important;
  text-align: center;
  width: 100%;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
}

.producto-input:disabled {
  color: inherit !important;
  background: transparent !important;
  cursor: default;
}

.trash-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.padlock-icon {
  opacity: 0.6;
  cursor: default;
}

.registered-row {
  background-color: #f2f2f2 !important;
}

.registered-row td {
  background-color: #f2f2f2 !important;
  border-color: #e0e0e0 !important;
}

.registered-row input,
.registered-row select {
  background-color: transparent !important;
  border-color: transparent !important;
}

.registered-row .status-badge {
  background-color: #f2f2f2 !important;
}

.registered-row .status-cell {
  background-color: #f2f2f2 !important;
}

.registered-row .input-with-info {
  background-color: #f2f2f2 !important;
}

.registered-row .status-badge.status-registered {
  background: #aed491 !important;
  color: #3f7623 !important;
  border-color: #348127 !important;
}

.registered-row .status-badge.status-error {
  background: #ffada9 !important;
  color: rgb(168, 53, 53) !important;
  border-color: #ff6a63 !important;
}

.registered-row .status-badge.status-not_registered {
  background: #91c9ff !important;
  color: #003ea7 !important;
  border-color: #76aeff !important;
}

.registered-row .status-badge.status-not_registered_edited {
  background: #d5d5d5 !important;
  color: #44587a !important;
  border-color: #677ea0 !important;
}

.registered-row .status-badge.status-error_edited {
  background: #d5d5d5 !important;
  color: #733f3f !important;
  border-color: #e49590 !important;
}

.registered-row .status-badge.status-legacy {
  background: #d5d5d5 !important;
  color: #616469 !important;
  border-color: #677ea0 !important;
}

.registered-row .padlock-icon {
  background-color: transparent !important;
  mix-blend-mode: multiply !important;
}

.registered-row img[src*='padlock'] {
  background-color: transparent !important;
  mix-blend-mode: multiply !important;
}

.registered-row img[src*='padlock'] {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg)
    brightness(104%) contrast(97%) !important;
  background-color: transparent !important;
}

.registered-row img[src*='padlock-icon.svg'] {
  background: transparent !important;
  mix-blend-mode: darken !important;
}

.registered-row img[src*='succes-padlock-icon.svg'] {
  background: transparent !important;
  mix-blend-mode: darken !important;
}

.registered-row img {
  background: transparent !important;
}

.data-table tbody tr:nth-child(even) {
  background-color: v-bind('props.enableZebraStriping ? "#F2F5F9" : "transparent"');
}

.data-table tbody tr:nth-child(odd) {
  background-color: v-bind('props.enableZebraStriping ? "#ffffff" : "transparent"');
}

.data-table tbody tr:nth-child(even) td {
  background-color: v-bind('props.enableZebraStriping ? "#F2F5F9" : "transparent"');
}

.data-table tbody tr:nth-child(odd) td {
  background-color: v-bind('props.enableZebraStriping ? "#ffffff" : "transparent"');
}

.data-table tbody tr:nth-child(even) input {
  background-color: v-bind('props.enableZebraStriping ? "#F2F5F9" : "transparent"');
}

.data-table tbody tr:nth-child(odd) input {
  background-color: v-bind('props.enableZebraStriping ? "#ffffff" : "transparent"');
}

.data-table tbody tr:nth-child(even) select {
  background-color: v-bind('props.enableZebraStriping ? "#F2F5F9" : "transparent"');
}

.data-table tbody tr:nth-child(odd) select {
  background-color: v-bind('props.enableZebraStriping ? "#ffffff" : "transparent"');
}
</style>
